import { AEMSvg } from "@components/AEMSvg"
import { Box, Flex, Text } from "@mantine/core"
import { FC } from "react"
import styles from "./MaintenanceBanner.module.css"
import { useAEMDictionary } from "@AEM/hooks/useAEMDictionary"
import { useAEMIcons } from "@AEM/hooks/useAEMIcons"

interface MaintenanceBannerProps {
	show?: boolean
}

export const MaintenanceBanner: FC<MaintenanceBannerProps> = ({
	show = false
}) => {
	if (!show) {
		return null
	}
	const { dictionary } = useAEMDictionary()
	const { icons } = useAEMIcons()

	return (
		<Flex
			align="center"
			justify="center"
			gap="md"
			className={styles.maintenanceBanner}
		>
			<AEMSvg svgData={icons["qa-mode.svg"]} w={24} h={24} />
			<Box>
				<Text fw={600} fz={14}>
					{dictionary?.qaModeAlertTitle}
				</Text>
				<Text fz={12} className={styles.subtitleText}>
					{dictionary?.qaModeAlertDescription}
				</Text>
			</Box>
		</Flex>
	)
}
